import { FunctionalComponent, h } from 'preact';

import { AgentModel } from 'common/data/agent/model';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { ProgressiveImageComponent } from 'common/module/progressive-image/component';

export const LeadTemplateInfoAgent: FunctionalComponent<{ agent: AgentModel }> = (props) => (
  <div className='contact-form__detail'>
    <div className='contact-form__image'>
      <ProgressiveImageComponent
        src={props.agent.links.image_desktop}
        classname='contact-form__img'
        alt={props.agent.name}
        placeholder={__('assets/common/agent-tile-placeholder.jpg')}
        preloader={__('assets/common/image-loader.svg')}
      />
    </div>
    <div className='contact-form__info'>
      <div className='contact-form__info-title'>
        <div className='contact-form__title contact-form__title--agent'>{props.agent.name}</div>
        <div className='contact-form__position'>{props.agent.position}</div>
      </div>
      <div className='contact-form__list'>
        <div className='contact-form__list-label'>{i18nTranslate('Broker')}:</div>
        <div className='contact-form__list-content contact-form__list-content--broker'>{props.agent.broker.name}</div>
      </div>
      <div className='contact-form__list'>
        <div className='contact-form__list-label'>
          {props.agent.broker.license_label === 'RERA' ? (
            <div>
              {i18nTranslate('BRN')}#
              <div className='contact-form__label-info'>
                <span
                  className='svg'
                  dangerouslySetInnerHTML={{
                    __html: `
                    <svg viewBox='0 0 12 12' class='contact-form__label-info-icon'>
                      <use xlink:href='#svg-info-icon'></use>
                    </svg>
                  `,
                  }}
                />
                <div className='tooltip2 tooltip2--bottom'>
                  <div className='tooltip2__content'>
                    {i18nTranslate(
                      'Broker Registration Number issued to agents working for RERA-registered ' + 'brokerages in Dubai'
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div>{i18nTranslate('License')}#</div>
          )}
        </div>
        <div className='contact-form__list-content'>{props.agent.agent_broker_license_no}</div>
      </div>
    </div>
  </div>
);
